import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useVersionCheck } from '../hooks/useVersionCheck';

export const VersionUpdateBanner: React.FC = () => {
  const { updateAvailable, snooze } = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 75,
        left: 16,
        right: 16,
        zIndex: 1050,
        maxWidth: 600,
        margin: '0 auto',
      }}
    >
      <Alert variant="warning" className="mb-0 py-3 d-flex align-items-center justify-content-center border-dark">
        <span className="me-10 fw-bolder fs-4">A new version is available</span>
        <Button variant="primary" size="sm" className="me-2" onClick={() => window.location.reload()}>
          Update
        </Button>
        <Button variant="outline-secondary text-primary" size="sm" onClick={snooze}>
          Snooze
        </Button>
      </Alert>
    </div>
  );
};
